import arrayFindIndex from 'array-find-index';
import merge from 'merge';

/**
 * Remove the element from the array that matches the provided key/value pair.
 * This is useful for removing items by ID.
 */
export function removeFromArray(arr, keyName, keyVal) {
  const index = arrayFindIndex(arr, e => e && e[keyName] === keyVal);
  return removeAtIndex(arr, index);
}

/**
 * Remove the item from the array at the specified index and return a new array.
 * If the index is out of bounds, return the original array.
 * This immutability is important for Redux
 */
export function removeAtIndex(arr, index) {
  if (index >= 0 && index < arr.length) {
    const copiedArray = [...arr];
    copiedArray.splice(index, 1);
    return copiedArray;
  }
  return arr;
}

export function removeValue(arr, value) {
  const index = arr.indexOf(value);
  if (index !== -1) {
    return removeAtIndex(arr, index);
  }
  return arr;
}

export function removeDuplicateValues(arr) {
  const seen = {};
  return arr.filter(item => {
    if (seen[item]) {
      return false;
    }
    seen[item] = true;
    return true;
  });
}

export function removeDuplicates(arr, keyName) {
  const seen = {};
  const newArray = arr.filter(obj => {
    const myVal = obj[keyName];
    if (typeof myVal !== 'undefined' && seen[myVal]) {
      return false;
    }
    seen[myVal] = true;
    return true;
  });
  if (newArray.length === arr.length) {
    return arr;
  }
  return newArray;
}

export function mergeDuplicates(arr, keyName) {
  const objectsByKey = {};
  const indexesByKey = {};
  const newArray = [];
  arr.forEach(arrayItem => {
    const keyVal = arrayItem[keyName];
    const oldObj = objectsByKey[keyVal];
    const oldIndex = indexesByKey[keyVal];
    if (oldObj) {
      const newObj = merge.recursive(arrayItem, oldObj);
      objectsByKey[keyVal] = newObj;
      newArray[oldIndex] = newObj;
    } else if (typeof arrayItem[keyName] !== 'undefined') {
      objectsByKey[keyVal] = arrayItem;
      indexesByKey[keyVal] = newArray.length;
      newArray.push(arrayItem);
    }
  });
  if (newArray.length === arr.length) {
    return arr;
  }
  return newArray;
}

export function findWhere(array, fn) {
  const index = arrayFindIndex(array, el => fn(el));
  if (index !== -1) {
    return array[index];
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/app/utils/array.js